module.exports = __webpack_public_path__ + "static/media/peh.ba2106cd.pdf";